// Formato opaco de id de localidade do catálogo do MuviHub — espelha
// Muvi Hub/.../DTOs/Saga/LocalityId.cs (prefixo + GUID). Um id fora desse formato (ex: numérico do
// legado/provedor) é rejeitado pelo backend (SearchTripsQueryValidator) com 422.
const LOCALITY_ID_PATTERN = /^loc_(city|term)_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isValidLocalityId(id) {
	return typeof id === 'string' && LOCALITY_ID_PATTERN.test(id)
}
